export default "__VITE_ASSET__DnoK63m0__"